import type { Dispatch } from '@reduxjs/toolkit'

import { branchesApi } from './api/branches'
import { invalidateGraphData } from './api/cache-coherence/graph-data-invalidation'
import { setOntologyBranch } from './api/core'

export type BranchListener = (next: string | undefined) => void

/** Same-tab subscribers ('storage' events only fire cross-tab). */
export const branchListeners = new Set<BranchListener>()

export function notifyBranchChange(next: string | undefined): void {
  for (const listener of branchListeners) listener(next)
}

/**
 * Adopt `branchId` as the active branch without opening it — for
 * programmatic switches where the server already opened the branch
 * (ingest jobs at begin, agent applies). Persists the header value,
 * wakes same-tab `useActiveBranch` subscribers, and invalidates every
 * branch-scoped RTK Query cache so the UI refetches against the new
 * `X-Ontology-Branch`. User-driven switches go through `useSwitchBranch`,
 * which opens first and then lands here.
 */
export function applyBranchSwitch(dispatch: Dispatch, branchId: string | undefined): void {
  setOntologyBranch(branchId)
  notifyBranchChange(branchId)
  dispatch(branchesApi.util.invalidateTags(['Branches']))
  invalidateGraphData(dispatch)
}
